import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Maintenance from './Maintenance';

// Set REACT_APP_MAINTENANCE=true in .env.production and push to show the notice on every page.
const maintenance = process.env.REACT_APP_MAINTENANCE === 'true';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {maintenance ? <Maintenance /> : <App />}
  </React.StrictMode>
);
